export * from './splash-picture'
